module.exports = __webpack_public_path__ + "images/signup/man.23263530.svg";